import React from "react";

export default function Link() {
  return (
    <div className="link">
      <a
        href="https://github.com/Savijacks95/Savs-React-App"
        target="_blank"
        rel="noopener noreferrer"
      >
        Created by: Savannah Jackson
      </a>
    </div>
  );
}
